module.exports = __webpack_public_path__ + "media/assets/placeholder-ef09bcbf54b25717ace6ebe806ed3270.png";